import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanningProjectComponent } from './planning-project.component';
import { authGuard } from '../_shared/guards/auth.guard';
import { maintenanceGuard } from '../_shared/guards/maintenance.guard';

const routes: Routes = [
    {
        path: 'planning-project/:salesforceId',
        component: PlanningProjectComponent,
        canActivate: [authGuard, maintenanceGuard],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlanningProjectRoutingModule {}
